import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useVimOsContext } from 'src/hooks/vim/hooks/useVimOsContext';
import { AppLoader } from 'src/components/AppLoader';

export const EHRCommonLaunch = () => {
  const vimOs = useVimOsContext();
  const navigate = useNavigate();
  const [activationSet, setActivationSet] = useState(false);

  useEffect(() => {
    if (vimOs?.hub?.setActivationStatus && !activationSet) {
      vimOs.hub.setActivationStatus('ENABLED');
      setActivationSet(true);
    }
  }, [vimOs, activationSet]);

  useEffect(() => {
    // Once activation is set and we have confirmed the SDK is ready,
    // navigate to encounters page. The VimOSEncounterProvider will handle
    // navigating to specific encounter details when an encounter is received.
    if (activationSet && vimOs?.hub) {
      // Navigate to encounters as the default landing page
      navigate('/encounters', { replace: true });
    }
  }, [activationSet, vimOs, navigate]);

  return <AppLoader />;
};

export default EHRCommonLaunch;
